var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarlyAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22178_25878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3816 12.1172C27.5705 14.3672 27.3691 17.2394 25.9968 19.3696C27.0535 17.1004 27.2455 14.4755 26.3816 12.1172Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4241 3.47266C27.3297 4.48973 27.5367 6.02301 27.0173 7.25902C27.1936 5.89473 27.0457 4.71557 26.4241 3.47266Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4094 1.74501C19.3851 0.792467 20.9375 0.483659 22.2366 0.900012C20.8305 0.823194 19.64 1.04904 18.4094 1.74501Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8643 0.936315C19.1239 0.587561 19.6354 0.39398 20.0547 0.560675C19.6275 0.615984 19.2553 0.767316 18.8643 0.936315Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.342125 7.01172C0.202856 8.3883 0.486116 9.54287 1.1384 10.762C0.209938 9.78024 -0.14335 8.2723 0.342125 7.01172Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18763 2.4305C5.79729 2.16548 4.59108 2.33218 3.28809 2.8507C4.37706 2.04104 5.94758 1.83977 7.18763 2.4305Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65883 1.69299C5.22922 1.72448 4.83108 1.76289 4.42822 1.91653C4.71699 1.57546 5.26069 1.50939 5.65883 1.69606V1.69299Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2185 2.17969C11.9297 2.48696 11.6677 2.78501 11.4757 3.16373C11.4474 2.72202 11.7975 2.31028 12.2185 2.17969Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8601 16.5879C27.971 17.8231 27.4218 19.1482 26.5225 20.0124C26.5941 19.8703 26.6798 19.7413 26.7522 19.603C27.2841 18.6622 27.6582 17.6443 27.8601 16.5879Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02592 12.1328C2.05024 14.4496 2.11555 17.0799 3.0629 19.3952C1.79295 17.2028 1.72922 14.3267 3.02592 12.1328Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70335 13.4609C1.45755 14.5086 1.38503 15.588 1.48854 16.658C1.49798 16.8117 1.52474 16.9653 1.5326 17.1189C1.0605 15.9759 1.0967 14.5471 1.70335 13.457V13.4609Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6804 6.81534L21.1729 6.44123L24.6239 1.97427C24.6488 1.94139 24.6801 1.91368 24.7161 1.89279C24.7521 1.87189 24.792 1.85821 24.8335 1.85256C24.875 1.84691 24.9172 1.84939 24.9577 1.85987C24.9982 1.87035 25.0361 1.88861 25.0692 1.91358C25.1029 1.93788 25.1313 1.96849 25.1527 2.00363C25.1741 2.03877 25.1881 2.07773 25.1939 2.11822C25.1997 2.15871 25.1971 2.19993 25.1864 2.23945C25.1757 2.27897 25.157 2.316 25.1314 2.34837L21.6804 6.81534Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.2869 6.29297L21.752 6.72238L21.6811 6.81456L21.1729 6.44046L21.2869 6.29297Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.8635 6.57942L21.3984 6.15078L21.4693 6.05859L21.9768 6.43193L21.8635 6.57942Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6868 9.15556L17.7673 3.32507C18.5593 2.29978 19.736 1.62362 21.0386 1.44534C22.3411 1.26707 23.6629 1.60128 24.7131 2.37445C25.7633 3.14762 26.4559 4.29642 26.6385 5.56812C26.8211 6.83983 26.4787 8.13027 25.6868 9.15556Z",
    fill: "var(--service-details-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6868 9.15556L17.7673 3.32507C18.5593 2.29978 19.736 1.62362 21.0386 1.44534C22.3411 1.26707 23.6629 1.60128 24.7131 2.37445C25.7633 3.14762 26.4559 4.29642 26.6385 5.56812C26.8211 6.83983 26.4787 8.13027 25.6868 9.15556Z",
    fill: "var(--service-details-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.8668 2.50524C23.0114 1.36372 20.3362 2.01975 18.7625 4.0585L18.2668 3.69361C19.9192 1.55884 22.7628 0.940455 24.626 2.31089C24.711 2.37695 24.7905 2.43764 24.8668 2.50524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04268 8.29725L6.46757 7.83634L2.20294 4.09838C2.17205 4.07072 2.13581 4.04937 2.09636 4.03557C2.0569 4.02178 2.01502 4.01581 1.97317 4.01803C1.93132 4.02025 1.89035 4.0306 1.85265 4.04849C1.81496 4.06638 1.7813 4.09143 1.75366 4.12219C1.72533 4.15235 1.70346 4.18772 1.68933 4.22625C1.6752 4.26477 1.66909 4.30566 1.67136 4.34651C1.67363 4.38737 1.68424 4.42737 1.70256 4.46417C1.72088 4.50097 1.74655 4.53383 1.77805 4.56082L6.04268 8.29725Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.32774 7.71094L5.95557 8.21947L6.04369 8.29629L6.46779 7.83461L6.32774 7.71094Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.81785 8.09902L6.19002 7.59049L6.10189 7.51367L5.677 7.97535L5.81785 8.09902Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57215 11.3426L9.19728 4.13705C8.21857 3.27933 6.93094 2.83632 5.61766 2.90547C4.30438 2.97462 3.07302 3.55027 2.19447 4.50578C1.31593 5.46129 0.862156 6.7184 0.932984 8.00055C1.00381 9.2827 1.59344 10.4849 2.57215 11.3426Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57215 11.3426L9.19728 4.13705C8.21857 3.27933 6.93094 2.83632 5.61766 2.90547C4.30438 2.97462 3.07302 3.55027 2.19447 4.50578C1.31593 5.46129 0.862156 6.7184 0.932984 8.00055C1.00381 9.2827 1.59344 10.4849 2.57215 11.3426Z",
    fill: "var(--service-details-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.06836 4.66311C3.66799 3.19435 6.41639 3.338 8.36302 5.0472L8.77768 4.59628C6.73978 2.81026 3.82063 2.73651 2.26585 4.43189C2.19583 4.50486 2.12973 4.58245 2.06836 4.66311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14208 24.3906L7.49609 27.501L8.60631 27.3957L10.4979 25.5429L8.14208 24.3906Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.14208 24.3906L7.49609 27.501L8.60631 27.3957L10.4979 25.5429L8.14208 24.3906Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6435 23.0195L23.889 25.9509L22.7788 26.0561L20.5583 24.592L22.6435 23.0195Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.6435 23.0195L23.889 25.9509L22.7788 26.0561L20.5583 24.592L22.6435 23.0195Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5218 2.54749L12.0901 2.77734L12.1895 3.77974L14.6212 3.54989L14.5218 2.54749Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0016 3.60608L12.8096 3.71875L12.9029 4.65998L14.0949 4.54731L14.0016 3.60608Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0181 3.77837L12.834 3.96735L12.8096 3.72153L14.0016 3.60938L14.0181 3.77837Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6218 23.204C27.0727 18.8586 27.0727 11.8133 22.6218 7.4679C18.1709 3.1225 10.9546 3.1225 6.50366 7.4679C2.05275 11.8133 2.05275 18.8586 6.50366 23.204C10.9546 27.5494 18.1709 27.5494 22.6218 23.204Z",
    fill: "var(--service-main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2342 22.6636C26.4811 18.5174 26.4811 11.7951 22.2342 7.64888C17.9874 3.50268 11.1018 3.50268 6.85493 7.64888C2.60806 11.7951 2.60806 18.5174 6.85493 22.6636C11.1018 26.8098 17.9874 26.8098 22.2342 22.6636Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5586 25.2154C20.1727 25.2154 24.7237 20.7722 24.7237 15.2913C24.7237 9.81037 20.1727 5.36719 14.5586 5.36719C8.94462 5.36719 4.39355 9.81037 4.39355 15.2913C4.39355 20.7722 8.94462 25.2154 14.5586 25.2154Z",
    fill: "#F4FBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9641 9.85056L14.0418 19.6059C13.9724 19.7203 13.8758 19.8159 13.7607 19.8844C13.6455 19.9529 13.5152 19.9923 13.3812 19.999C13.2472 20.0057 13.1136 19.9795 12.9921 19.9229C12.8706 19.8662 12.7649 19.7807 12.6843 19.6739L9.54778 15.5154C9.39732 15.3151 9.63115 15.0537 9.84798 15.1799L13.0752 17.0552L19.5935 9.58146C19.7781 9.3699 20.1096 9.61005 19.9641 9.85056Z",
    fill: "var(--service-details-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22178_25878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.75,
    height: 27,
    fill: "white",
    transform: "translate(0.125 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyAccess);
export default __webpack_public_path__ + "static/media/earlyAccess.950dcc40a7ff260ea5f9262c9c3c7ef9.svg";
export { ForwardRef as ReactComponent };